import React from "react";
import { TextField } from "@mui/material";

interface MembershipColumnFilterFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  "aria-label"?: string;
}

const MembershipColumnFilterField: React.FC<
  MembershipColumnFilterFieldProps
> = ({ value, onChange, placeholder = "Filter…", "aria-label": ariaLabel }) => (
  <TextField
    size="small"
    fullWidth
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    aria-label={ariaLabel}
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
    InputProps={{
      sx: {
        fontSize: "0.8125rem",
        bgcolor: "background.paper",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "divider",
        },
      },
    }}
  />
);

export default MembershipColumnFilterField;
